export default "__VITE_ASSET__Lq$nbrQc__"